import classNames from "classnames";
import { Divider } from "primereact/divider";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { AppFooter } from "../../components/appFooter";
import AppMenu from "../../components/appMenu";
import Topbar from "../../components/topbar";
import { GeneralInfo } from "../../context/infoContext";

export default function DashboardLayout() {
  const [showSidebar, setShowSidebar] = useState(true)

  return (
    <div className="grid overflow-hidden">
      <GeneralInfo>
        <Topbar toggleSidebar={() => setShowSidebar(prevSidebar => !prevSidebar)} />
        <div className={classNames(
          "fixed top-28 left-8 z-50 w-80",
          "min-h-[calc(100vh-7rem)] max-h-[calc(100vh-7rem)]",
          "transition-all duration-300",
          {
            "ml-[-22rem] transition-all duration-300": !showSidebar
          })
        }>
          <AppMenu />
        </div>
        <div 
          className={classNames("fixed lg:hidden block w-full h-full top-0 bottom-0 left-0 right-0 bg-gray-900/60 z-10 cursor-pointer",
            {
              "hidden": !showSidebar
            }
          )}
          onClick={() => {setShowSidebar(prevSidebar => !prevSidebar)}}
        />
        <div className={classNames("mt-28 px-6 transition-all duration-300",
          // "min-w-[80vh]",
          {
            "lg:ml-[22rem] transition-all duration-300": showSidebar
          }
        )}>
          <div className="min-h-[74vh]">
            <Outlet />
          </div>
          <Divider />
          <AppFooter />

        </div>
      </GeneralInfo>
    </div>
  );
}